<script setup>
import {computed} from 'vue'
import {useDisplayOrdersStore} from '@/stores/displayOrders'
import {useViewStore} from '@/stores/view'

const props = defineProps({
    viewId: String,
    item: Object
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Access Pinia store for displayOrders
const displayOrdersStore = useDisplayOrdersStore()

const tableName = computed(() => viewStore.tableName)

const displayOrder = computed(() => {
    return displayOrdersStore.data[tableName.value]?.[props.item.id]
})
</script>

<template>
    <span>{{ displayOrder }}</span>
</template>